import axios from "axios";
import { errorPopup } from "./swirlfire";
import { NODE_SERVER_URL } from "@/constants";

// Axios instance without token
export const chatServerInstance = axios.create({
    baseURL: NODE_SERVER_URL,
    headers: {
        "Content-Type": "application/json",
    },
});

// Axios instance with token
export const chatServerInstanceWithToken = axios.create({
    baseURL: NODE_SERVER_URL,
    headers: {
        "Content-Type": "application/json",
    },
});

// Interceptor to add token dynamically for the instance with token
chatServerInstanceWithToken.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem("token"); // Retrieve token from localStorage
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
            config.headers.XCustomHeader = 'c41e86207c16d42b4d2f432c620134d9' // Additional header
        }
        return config;
    },
    (error) => {
        // Handle request errors
        errorPopup("Request Error:", error.message);
        return Promise.reject(error);
    }
);


// Response interceptor for error handling
chatServerInstanceWithToken.interceptors.response.use(
    (response) => {
        // Return response if successful
        return response;
    },
    (error) => {
        // Handle response errors
        if (error.response) {
            // Server responded with a status other than 2xx
            errorPopup("", error.response.data.message === 'Unauthenticated.' ? 'Please login first!' : error.response.data.message);
        } else if (error.request) {
            // No response received
            errorPopup("", error.request);
        } else {
            // Something else happened while setting up the request
            errorPopup("Error:", error.message);
        }
        return Promise.reject(error);
    }
);

// Adding similar error handling for chatServerInstanceWithToken (without token)
chatServerInstance.interceptors.response.use(
    (response) => {
        return response;
    },
    (error) => {
        if (error.response) {
            errorPopup("Response Error:", error.response.data.message);
        } else if (error.request) {
            errorPopup("No Response:", error.request);
        } else {
            errorPopup("Error:", error.message);
        }
        return Promise.reject(error);
    }
);
